<template>
  <div class="list">
    <van-nav-bar title="我的预约" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>

    <div class="item" v-for="item in list" :key="item.id" v-on:click="$router.push('/qiang/detail/'+item.goods_id)">
      <div class="l">
        <van-image fit="contain" :src="GLOBAL.IMG + item.thumbnail" width="100" height="100" />
      </div>
      <div class="r">
        <div class="title">{{item.post_title}}</div>
        <div class="price">¥{{item.price}}</div>
        <div>抢购开始：{{item.q_time_begin_str}}</div>
        <div>抢购结束：{{item.q_time_end_str}}</div>
      </div>
    </div>
    <div style="height:46px"></div>
    <TabBar active="4" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
Date.prototype.format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
export default {
  name: "money",
  components: {
    TabBar
  },
  data() {
    return {
      list: [],
      user: { token: "", user: {} },
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "s_qiang/appointment/my", {
          params: {},
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          for(var i in data.data){
              data.data[i].q_time_begin_str = new Date(data.data[i].q_begin_time*1000).format("yyyy-MM-dd hh:mm:ss");
              data.data[i].q_time_end_str = new Date(data.data[i].q_end_time*1000).format("yyyy-MM-dd hh:mm:ss");

          }
          this.list = data.data; 
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.onLoad();
  }
};
</script>
<style lang="scss" scoped>
.list {
  text-align: left;
  background-color: #f6f6f6;
  .item {
    background-color: #fff;
    display: flex;
    padding: 10px 10px 0 10px;
    margin-top: 10px;
    .l {
        padding-right:10px;
    }
    .r {
      .title {
        line-height: 25px;
        height: 50px;
        overflow: hidden;
        padding: 0 5px 0 5px;
      }
      .price {
        color: red;
        text-align: left;
        padding: 0 5px 0 5px;
      }
    }
  }
}
</style>